import { createContext } from 'react';

import type {
  ConvertibleUnit,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import type { Formatter } from '../../core/types/formatter.js';

interface FormatterContextProps {
  formatter: Formatter | FormatOptions<Unit, ConvertibleUnit> | undefined;
  unit?: string | Unit;
}

export const GaugeChartFormatterContext = createContext<FormatterContextProps>({
  formatter: undefined,
  unit: '',
});
